export default "__VITE_ASSET__ok3eA_kX__"